import { render, staticRenderFns } from "./SoftPosBindingModal.vue?vue&type=template&id=4d510be6&scoped=true"
import script from "./SoftPosBindingModal.vue?vue&type=script&lang=js"
export * from "./SoftPosBindingModal.vue?vue&type=script&lang=js"
import style0 from "./SoftPosBindingModal.vue?vue&type=style&index=0&id=4d510be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d510be6",
  null
  
)

export default component.exports